<template>
	
	<div id="porque-nosotros">

	  <v-parallax 
	    :src="backend+'../storage/app/public/porque-nosotros.webp'"
	    height="640"
	  >
	    
	    <v-container>

	    	<div id="message">
	    		
	    		<h1 class="text-center">¿Porque nosotros?</h1>

	    		<p id="mess-text">
	    		  {{porque_nosotros}}
	    		</p>

	    	</div>
	      

	    </v-container>

	  </v-parallax>

	</div>

</template>


<style>
		
	#message {
		background: rgba(0, 0, 0, .7);
		padding: 20px;
		border-radius: 10px;
		width: 80%;
		height: auto;
		margin: auto;
	}

	#message * {
		color: #d0d0d0 !important;
	}

	#mess-text {
		text-align: center;
		margin-top: 30px;
		color: black;
	}

	@media(max-width: 672px) {

		#message {
			padding: 10px;
			width: 90%;
		}

		#mess-text {
			margin-top: 20px;
			height: 100px;
			overflow: hidden;
		}

	}

</style>


<script>
	
	import SettingService from '@/shared/services/SettingService'

	export default
	{
		data() {
			return {
				porque_nosotros: null
			}
		},

		created() {
			this.getAbout()
		},

		methods: {

			async getAbout()
			{
				const resp = await SettingService.get()
				this.porque_nosotros = resp.data.porque_nosotros
			}

		}
	}

</script>